import { useState } from 'react';

import ClaimsStatusTracker from '@/pages/claims/status/[claimNumber]/ClaimStatusTracker';
import ClaimStatusLookup from '@/pages/claims/status/ClaimStatusLookup';

export type ClaimData = {
  claim_number: string;
  status: 'under_review' | 'pending' | 'open' | 'closed' | 'cancelled';
  coverage_type: string;
  vehicle_description: string;
  incident_date: string;
  incident_location: string;
  filed_date: string;
  estimated_resolution: string;
  adjuster_name: string;
  claim_team_email: string;
  policy_number: string;
  current_step: number;
  total_steps: number;
  current_step_label: string;
  last_updated: string;
  next_update_date?: string;
  next_update_description?: string;
  timeline_steps: Array<{
    label: string;
    description?: string;
    date?: string;
    status: 'completed' | 'in_progress' | 'pending';
  }>;
};

const endpoint = `${process.env.coreApiHost}/claims/status`;

export default function ClaimStatusPage() {
  const [claim, setClaim] = useState<ClaimData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  function reload() {
    if (claim) {
      handleLookup(claim?.claim_number, claim?.incident_date?.split('T')[0] ?? '');
    }
  }

  const handleLookup = async (claimNumber: string, dateOfLoss: string) => {
    setIsLoading(true);
    setError(undefined);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify({ claim_number: claimNumber, date_of_loss: dateOfLoss }),
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        setError('Unable to find that claim. Please check your claim number and date of loss.');
        return;
      }

      const data: ClaimData = await response.json();

      setClaim({ ...data, claim_number: claimNumber });
    } catch {
      setError('Unable to find that claim. Please check your claim number and date of loss.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!claim) {
    return <ClaimStatusLookup onSubmit={handleLookup} isLoading={isLoading} error={error} />;
  }

  return (
    <ClaimsStatusTracker
      {...claim}
      onBack={() => {
        setClaim(null);
      }}
      onNotifyEmail={() => {}}
      onNotifyText={() => {}}
      isLoading={isLoading}
      reload={reload}
    />
  );
}
